"use client";

import { MailCheck } from "lucide-react";
import { useTranslations } from "next-intl";

interface ConfirmEmailStepProps {
  /** Email the verification link was sent to. */
  email: string;
}

/**
 * Mid-flow email-confirmation gate (design `14510:5069`). Shown right after
 * account creation: the user must open the verification email and follow its
 * link to continue. There is intentionally no resend or continue button — the
 * verify link (handled by the verify route) is what resumes the funnel.
 */
export default function ConfirmEmailStep({ email }: ConfirmEmailStepProps) {
  const t = useTranslations("publicEventSignup");

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 py-4 text-center">
      <MailCheck className="h-12 w-12 text-brand" aria-hidden />
      <h2 className="text-lg font-semibold">{t("steps.confirmEmail")}</h2>
      <p className="text-sm text-muted-foreground">
        {t("confirmEmailBody", { email })}
      </p>
    </div>
  );
}
